import { RoomCodeSchema } from '@concept/protocol';

export function parseRoomInvite(rawValue: string, baseUrl = 'https://concept.invalid/'): string | null {
  const direct = RoomCodeSchema.safeParse(rawValue.trim());
  if (direct.success) return direct.data;

  let url: URL;
  try {
    url = new URL(rawValue.trim(), baseUrl);
  } catch {
    return null;
  }

  const pathCode = url.pathname.match(/\/join\/([^/]+)\/?$/i)?.[1];
  const candidates = [
    url.searchParams.get('room'),
    url.searchParams.get('code'),
    url.searchParams.get('roomCode'),
    pathCode,
  ];
  for (const candidate of candidates) {
    const parsed = RoomCodeSchema.safeParse(candidate ?? '');
    if (parsed.success) return parsed.data;
  }
  return null;
}

export function roomInviteUrl(roomCode: string, origin: string): string {
  const code = RoomCodeSchema.parse(roomCode);
  const url = new URL('/', origin);
  url.searchParams.set('room', code);
  return url.toString();
}
